var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStrd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3344_32598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3344_32598",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37259 18.6274 0 12 0C5.37259 0 0 5.37259 0 12C0 18.6274 5.37259 24 12 24Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3344_32598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "#E50571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3802 18.0598C10.8848 18.0598 9.65914 17.7277 8.70327 17.0633C7.82545 16.4532 7.26615 15.6028 7.02548 14.5124C6.98871 14.3458 7.09249 14.1834 7.25367 14.1406L9.32266 13.5915C9.50117 13.5443 9.68031 13.6611 9.73018 13.8433C9.83833 14.2385 9.98933 14.5606 10.1834 14.8093C10.4453 15.1257 10.7614 15.355 11.1314 15.4974C11.5169 15.624 11.9331 15.6872 12.3802 15.6872C13.0586 15.6872 13.5596 15.5685 13.8834 15.3313C14.2071 15.0782 14.369 14.7698 14.369 14.406C14.369 14.0422 14.2148 13.7654 13.9065 13.5755C13.5981 13.3699 13.1048 13.2038 12.4265 13.0772L11.779 12.9587C10.9772 12.8005 10.245 12.5869 9.58205 12.3181C8.91908 12.0333 8.38724 11.6458 7.98639 11.1555C7.58559 10.6651 7.38519 10.0323 7.38519 9.25734C7.38519 8.08681 7.8014 7.19315 8.63391 6.57621C9.46647 5.94352 10.561 5.6272 11.9177 5.6272C13.1973 5.6272 14.261 5.91981 15.109 6.50502C15.8637 7.02597 16.3864 7.69096 16.6769 8.50009C16.7373 8.66819 16.6407 8.84862 16.4738 8.90128L14.4046 9.55456C14.2241 9.61153 14.0371 9.4959 13.9758 9.31254C13.8351 8.89163 13.6115 8.58059 13.3052 8.37947C12.9352 8.12637 12.4727 7.99984 11.9177 7.99984C11.3627 7.99984 10.9387 8.10265 10.6458 8.30829C10.3529 8.49808 10.2064 8.76697 10.2064 9.11502C10.2064 9.49461 10.3606 9.77934 10.669 9.96913C10.9772 10.1431 11.3934 10.2776 11.9177 10.3724L12.5652 10.4911C13.4285 10.6492 14.2071 10.8627 14.9009 11.1316C15.61 11.3848 16.1651 11.7565 16.5659 12.2468C16.9821 12.7214 17.1903 13.3699 17.1903 14.1925C17.1903 15.4262 16.7509 16.3832 15.8721 17.0633C15.0088 17.7277 13.8448 18.0598 12.3802 18.0598Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3344_32598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrd);
export default __webpack_public_path__ + "static/media/strd.7e519418b3e9fa498d1d257cddb4ad46.svg";
export { ForwardRef as ReactComponent };